<template>
  <div :class="elementClass">
    <Textfield
      ref="field"
      :disabled="disabled"
      type="text"
      @blur="blur"
      @focus="focus"
      @mounted="ready"
      :placeholder="placeholder"
      :value="internalValue"
      :required="required"
      :label="label"
    ></Textfield>
    <div
      ref="child"
      v-click-outside="onClickOutside"
      :class="dropdownClass"
      :style="{
        position: 'fixed',
        top: y + 'px',
        left: x + 'px',
        'z-index': 100,
      }"
    >
      <Textfield
        :noLine="true"
        class="background-white"
        :no-message="true"
        ref="search"
        v-model="searchValue"
        :disabled="disabled"
        type="text"
        :style="{ width: width + 'px', padding: 0 }"
        placeholder="Search"
      ></Textfield>
      <div class="list-box" :style="`max-height: 200px; width: auto; display: table; z-index: 100; overflow: auto; min-width: ${width}px`">
        <Scrollbar style="overflow: auto; max-height: 200px;">
          <list>
            <list-item v-for="(item, index) in filteredItems" :key="item.value" @click="select(index)" :class="{ active: item.value === value }">
              <div class="font-normal" style="white-space: nowrap">
                {{ item.text }}
              </div>
            </list-item>
            <list-item v-if="filteredItems.length === 0" style="pointer-events: none; cursor: default">
              <div class="font-normal color-grey-600">No Data Found</div>
            </list-item>
          </list>
        </Scrollbar>
      </div>
      <div class="line" :style="{ width: width - 2 + 'px', top: '45px', 'z-index': 100 }"></div>
    </div>
  </div>
</template>

<script>
import { dropdownFieldClass } from "../prefix";
import Textfield from "./Textfield";
import List from "./List";
import ListItem from "./ListItem";
import Scrollbar from "./Scrollbar";
import _ from "lodash";
import vClickOutside from "v-click-outside";

export default {
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    value: {
      default: "",
      type: String,
    },
    placeholder: {
      default: "",
      type: String,
    },
    items: {
      default: null,
      type: Array,
    },
    required: {
      default: false,
      type: Boolean,
    },
    label: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    Textfield,
    List,
    ListItem,
    Scrollbar,
  },
  computed: {
    elementClass() {
      return dropdownFieldClass;
    },
    dropdownClass() {
      return {
        dropdown: true,
        active: this.isActive,
      };
    },
    filteredItems() {
      var results = _.filter(this.items, obj => {
        return obj.text.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1;
      });

      return results;
    },
  },
  data() {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      isActive: false,
      isBlockBlur: false,
      searchValue: "",
      internalValue: "",
      lastCalledBlur: null,
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  methods: {
    ready(e) {
      document.body.appendChild(this.$refs.child);
      let data = e.getBoundingClientRect();
      this.x = data.x;
      this.y = data.y;
      this.width = data.width;
      this.height = data.height;
    },
    focus(e) {
      this.ready(e);
      this.isBlockBlur = true;
      setTimeout(() => {
        this.isActive = true;
        this.searchValue = "";
        setTimeout(() => {
          this.$refs.search.focusInput();
        }, 100);
      }, 100);
    },
    blur(selected = null) {
      if (!this.lastCalledBlur) this.lastCalledBlur = new Date();
      if (!this.isBlockBlur) {
        if (new Date() - this.lastCalledBlur > 500) {
          this.isActive = false;
          if (selected) {
            this.$emit("input", selected.value);
            this.internalValue = selected.text;
            this.lastCalledBlur = null;
          }
        }
      }
      this.isBlockBlur = false;
    },
    select(index) {
      this.isBlockBlur = false;
      this.blur(this.filteredItems[index]);
    },
    clear() {
      this.$emit("input", "");
    },
    dropdownMouseDown() {
      this.isBlockBlur = true;
      this.$emit("dropdownClick", "");
    },
    onClickOutside() {
      if (!this.isBlockBlur) {
        this.blur();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.items.forEach(item => {
        if (item.value === this.value) {
          this.internalValue = item.text;
        }
      });
      window.addEventListener("resize", () => {
        // let data = this.$refs.field.getInner().getBoundingClientRect();
        // this.x = data.x;
        // this.y = data.y + data.height - 1;
      });
    });
  },
  watch: {
    value(val) {
      this.items.forEach(item => {
        if (item.value === val) {
          this.internalValue = item.text;
        }
      });

      if (!this.value) {
        this.internalValue = "";
      }
    },
    searchValue(data) {
      this.$emit("searchChange", data);
    },
  },
  beforeDestroy() {
    document.body.removeChild(this.$refs.child);
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-dropdown-field";
$list: $prefix + "-list";

// #{$element} {
//     //nothing
// }
.dropdown {
  visibility: hidden;
  opacity: 0;
  @include transform(translateY(-30px) scaleY(0));
  transition: all 0.4s $animation-standard-curve-timing-function, opacity 0.15s $animation-sharp-curve-timing-function;
  @include transform-origin((50% 0));
  height: auto;
  &.active {
    transition: all 0.2s $animation-deceleration-curve-timing-function;
    visibility: visible;
    opacity: 1;
    box-shadow: 0 8px 16px 0px rgba(10, 14, 29, 0.04), 0px 8px 64px 0px rgba(10, 14, 29, 0.08);

    @include transform(translateY(0px) scaleY(1));
  }

  & > .line {
    height: 1px;
    position: absolute;
    background: white;
    left: 1px;
  }

  #{$list} {
    #{$list}-item.active {
      color: white;
      background: linear-gradient(65deg, $theme-primary 0, $theme-primary-200 100%);
    }
    margin-bottom: 4px;
  }

  .mad-textfield {
    .inner {
      border: 1px solid $theme-color;
      border-bottom: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .list-box {
    border: 1px solid $theme-color;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background: white;
  }
}
</style>
